export const __CategoryListLang = {
    all_category: 'تمام دسته بندی ها',
};
